import {
  Component, OnDestroy, OnInit,

} from '@angular/core';
import { MessageCenterService } from 'src/app/modules/core/services/message-center.service';
import { constants } from 'src/app/constants';
import { environment, BRAND } from '~environments/environment';
import * as utils from 'src/app/util';
import { AnalyticsService } from '../../modules/core/services/analytics.services';
import { TealiumService } from '../../modules/core/services/tealium.service';
import { debounceTime, Subject, Subscription, takeUntil } from 'rxjs';
import { analyticsConstants } from 'src/app/constants/analytics.constants';

@Component({
  selector: 'main-nav-message-center-box',
  templateUrl: './main-nav-message-center-box.component.html',
  styleUrls: ['./main-nav-message-center-box.component.scss'],
  standalone: false,
   host: {
      '(window:resize)': 'onWindowSizeChange()'
    }
})
export class MainNavMessageCenterBoxComponent implements OnInit,OnDestroy {

  private destroy$ = new Subject<void>();
  private resize$ = new Subject<void>();
  private lastHeight = window.innerHeight;

  public menuOpen = false;
  public apiConfig = {};
  public analyticsClientData = {};
  public language = '';
  public brand = '';
  public messageHubKey = 0;
  public menuOpenSubscription: Subscription;

  constructor(
    private messageCenterService: MessageCenterService,
    private analyticsService: AnalyticsService,
    private tealiumService:TealiumService
  ) {
      this.resize$
            .pipe(
                debounceTime(150),
                takeUntil(this.destroy$)
            )
            .subscribe(() => {
                const currentHeight = window.innerHeight;
                if (this.menuOpen && currentHeight !== this.lastHeight) {
                    this.lastHeight = currentHeight;
                    this.messageHubKey++;
                }
            });
  }

   ngOnInit(): void { 
    this.populateMessageCenterData();
    this.menuOpenSubscription = this.messageCenterService.currentMenuOpen.subscribe((menuOpen) => {
                this.menuOpen = menuOpen;
        });
    }
    
  populateMessageCenterData() {
      this.analyticsClientData =
        this.analyticsService.getAnalyticsDataForMessagingCenter();
      const cookieValue: any = utils.getDecodedAccessToken(
        constants.COOKIES.OLCI.OLCI_DATA
      );
  
      if (!cookieValue) {
        return;
      }

      this.language = cookieValue.locale || 'en-US';
      this.brand = BRAND;
  
      this.apiConfig = {
        accessToken: utils.readCookie(constants.COOKIES.OLCI.ACCESS_TOKEN),
        accountId: cookieValue.vdsId,
        brand: this.brand,
        environment: utils.returnEnvironment(environment?.envName as string),
        language: this.language,
      };
    }
  
    customErrorEvent(event: any) {
      this.tealiumService.dispatchSplunkMessageCenterView(event);
    }

    notificationClickEmitter(event: any) {
      if (event?.detail?.notificationUrl?.includes("cruise-planner")) {
        localStorage.setItem(analyticsConstants.MESSAGE_CENTER.LOCAL_STORAGE_KEY_CRUISE_PLANNER, analyticsConstants.MESSAGE_CENTER.PANEL_TYPE);
      }
  
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
      if (this.menuOpenSubscription) {
        this.menuOpenSubscription.unsubscribe();
      }
    }
     onWindowSizeChange(): void {
        // Emit to debounced stream
        this.resize$.next();
    }
}
